import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators
} from '@angular/forms';
import { HomeService } from './home.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  close: boolean = true;
  toppings = new FormControl();
  selectedValue = [];
  selectedValue2 = [];
  selectedValue3 = [];
  serverUrl: FormGroup;
  Obj: any = {};
  toppingList: string[] = ['The Regence Group'];
  toppingList2: string[] = ['REGENCE BLUESHIELD'];
  toppingList3: string[] = ['InPatient Authorization'];
  url: String;
  mataDataJson: Object;
  showData: boolean = false;

  constructor(
    public Router: Router,
    private fb: FormBuilder,
    public HomeService: HomeService
  ) {}

  ngOnInit() {
    this.serverUrl = this.fb.group({
      url: ['', Validators.required]
    });
  }

  clickOk(url) {
    this.showData = true;
    console.log(url);
    this.HomeService.getMetadataJson(url).subscribe(data => {
      this.mataDataJson = data.body;
    });
  }

  btnClick() {
    this.Obj = {
      Organization: this.selectedValue,
      Payer: this.selectedValue2,
      TransactionType: this.selectedValue3
    };
    localStorage.setItem('selectedValues', JSON.stringify(this.Obj));
    this.Router.navigateByUrl('/authorization');
  }

  closeClick() {
    this.close = false;
  }
}
